import React from "react";
import logo from "../../media/logo.png"
import {Link} from "react-router-dom";

function LandingFooter() {
    return (
        <section className="footer section-padding">
            <div className="w-layout-blockcontainer container w-container">
                <div data-w-id="3cf30eb6-5a85-ebaa-8c48-e9968a406cb4" className="content-wrapper footer">
                    <div className="footer-logo">
                        <div className="title">
                            <a href="/" aria-current="page" className="logo w-inline-block w--current">
                                <img src={logo} loading="lazy" alt="" className="logo h-[70px] w-24 max-h-[70px] max-w-24"/>
                            </a>
                            <p className="body-text-20 text-neutral-01 opacity">
                                Experience the Future of the Cloud Monitoring with Secure, Transparent, and Decentralized Solutions
                            </p>
                        </div>
                        <div className="social-icons">
                            <a href="https://www.facebook.com/" className="social-icon w-inline-block">
                                <img
                                    src="https://cdn.prod.website-files.com/66dd49508eee94442464a25c/66e024158ddb3dd54961ca54_Facebook%20(2).svg"
                                    loading="lazy" alt="" className="social-midea-icon"/>
                            </a>
                            <a href="https://www.linkedin.com/" className="social-icon w-inline-block">
                                <img
                                    src="https://cdn.prod.website-files.com/66dd49508eee94442464a25c/66e024a4b80981e5c5f88d29_Linkedin%20(3).svg"
                                    loading="lazy" alt="" className="social-midea-icon"/>
                            </a>
                            <a href="https://twitter.com/" className="social-icon w-inline-block">
                                <img
                                    src="https://cdn.prod.website-files.com/66dd49508eee94442464a25c/66e024a4dc892865854222f1_X%20(2).svg"
                                    loading="lazy" alt="" className="social-midea-icon"/>
                            </a>
                            <a href="https://www.instagram.com/" className="social-icon w-inline-block">
                                <img
                                    src="https://cdn.prod.website-files.com/66dd49508eee94442464a25c/66e024a48f5782335c6febb5_Instagram.svg"
                                    loading="lazy" alt="" className="social-midea-icon"/>
                            </a>
                        </div>
                    </div>
                    <div className="footer-menu">
                        <div id="w-node-_3cf30eb6-5a85-ebaa-8c48-e9968a406cc5-8a406cb2" className="footer-item-wrapper">
                            <p className="body-text-16 bold text-neutral-01">Menu</p>
                            <div className="title">
                                <Link to="/" aria-current="page" className="footer-item body-text-16 w--current">Home</Link>
                                <Link to="/contact" className="footer-item body-text-16">Contact Us</Link>
                            </div>
                        </div>
                        <div id="w-node-_3cf30eb6-5a85-ebaa-8c48-e9968a406ccd-8a406cb2" className="footer-item-wrapper">
                            <p className="body-text-16 bold text-neutral-01">Info</p>
                            <div className="title">
                                <Link to="/terms-and-conditions" className="footer-item body-text-16">Terms</Link>
                                <Link to="/privacy-policy" className="footer-item body-text-16">Privacy Policy</Link>
                            </div>
                        </div>
                        <div id="w-node-_3cf30eb6-5a85-ebaa-8c48-e9968a406cd5-8a406cb2" className="footer-item-wrapper">
                            <p className="body-text-16 bold text-neutral-01">Resources</p>
                            <div className="title">
                                <Link to="/blog" className="footer-item body-text-16">Blogs</Link>
                                <Link to="/license" className="footer-item body-text-16">License</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default LandingFooter;